import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import { UserOutlined } from "@ant-design/icons";
import LockOpenIcon from "@mui/icons-material/LockOpen";

import { Button, Checkbox, Form, Input, Select, TreeSelect } from "antd";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

export default function Auth() {
  let [errorMsg, setErrorMsg] = useState(null);
  let [loading, setLoading] = useState(false);
  let [treeData, setTreeData] = useState(false);
  const messageApi = useMessage();
  let navigate = useNavigate();

  let getAuthed = async (values) => {
    try {
      setLoading(true);
      localStorage.clear();
      let { data } = await axiosInstance.post("/api/login", {
        name: values.username,
        password: values.password,
        branch_id: values.branch_id,
      });

      console.log(data);

      if (data.token && data.success) {
        localStorage.setItem("token", data.token);
        navigate("/");
      }
    } catch (error) {
      setErrorMsg(error.message);

      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  let getBranches = async (values) => {
    try {
      setLoading(true);
      localStorage.clear();
      let { data } = await axiosInstance.get("/api/register/branch");

      console.log(data);
      if (data.success) {
        setTreeData([
          ...data.data.map((el) => {
            return {
              label:
                el.name +
                ", " +
                el.owner_name +
                ", " +
                el.phone +
                ", " +
                el.address,
              value: el.id,
            };
          }),
        ]);
        localStorage.setItem("branches", JSON.stringify(data.data));
      }
    } catch (error) {
      setErrorMsg(error.message);

      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    getBranches();
    if (token) {
      navigate("/");
    }
  }, []);

  const [value, setValue] = useState();
  const onChange = (newValue) => {
    setValue(newValue);
  };
  return (
    <div className="min-h-screen flex items-center justify-center">
      {loading ? <Loading /> : <></>}
      <div className="max-w-[500px] w-[90%] flex flex-col gap-[20px] items-start justify-center">
        <h2 className="text-2xl font-bold mb-2">Tizimga kirish...</h2>{" "}
        {treeData.length ? (
          <Form
            layout="vertical"
            name="basic"
            size="large"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 24,
            }}
            style={{
              width: "100%",
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={getAuthed}
            onFinishFailed={onFinishFailed}
            autoComplete="on"
          >
            <Form.Item
              label="Omboringizni tanlang"
              name="branch_id"
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Yozilishi shart!",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a person"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[...treeData]}
              />
            </Form.Item>

            <Form.Item
              label="Ism"
              name="username"
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Yozilishi shart!",
                },
              ]}
            >
              <Input style={{ width: "100%" }} />
            </Form.Item>
            {/* className="w-[100%]" */}
            <Form.Item
              label="Parol"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Yozilishi shart!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 0,
                span: 16,
              }}
            >
              <Button type="primary" htmlType="submit">
                Kirish
              </Button>
            </Form.Item>
          </Form>
        ) : null}
      </div>
    </div>
  );
}
